import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import './toasts.scss';

const config = {
  position: 'bottom-center',
  autoClose: 3000,
  hideProgressBar: false,
  newestOnTop: false,
  closeOnClick: true,
  rtl: false,
  pauseOnVisibilityChange: true,
  draggable: true,
  pauseOnHover: true,
};

const ToastContainerWrapper = () => <ToastContainer {...config} />;

export default ToastContainerWrapper;



// WEBPACK FOOTER //
// ./src/components/Toasts/ToastContainerWrapper.jsx